import { ActionTypes } from "../contants/Action.Type";
import { addToCart } from "./Cart.Action";

export const NewProductList = (Products) => (dispatch) => {
  dispatch({ type: ActionTypes.SET_PRODUCTS, payload: { Products } });
  dispatch({ type: ActionTypes.SET_FILTER_PRODUCT, payload: { Products } });
};
export const NewCategory = (Category) => (dispatch) => {
  dispatch({ type: ActionTypes.SET_PRODUCT_CATEGORY, payload: { Category } });
};
export const ProductSearch = (searchdata) => (dispatch, getState) => {
  const Products = dispatch(Search(searchdata));
  dispatch({ type: ActionTypes.SET_FILTER_PRODUCT, payload: { Products } });
};

export const BarCodeProduct = (product) => (dispatch, getState) => {
  const currentCart = getState().Cart.CurrentCart;
  if (product && currentCart.length !== 0) {
    dispatch(addToCart(product, "", "", 1));
  }
};
const Search = (searchdata) => (dispatch, getState) => {
  const Prod = getState().Products.Products;
  let Products = Prod.filter(
    (p) =>
      p.name.toLowerCase().indexOf(searchdata.toLowerCase()) >= 0 ||
      p.category.toLowerCase().indexOf(searchdata.toLowerCase()) >= 0 ||
      p.category_id.toLowerCase().indexOf(searchdata.toLowerCase()) >= 0 ||
      p.id.toLowerCase().indexOf(searchdata.toLowerCase()) >= 0
  );
  return Products;
};
